import React, { Component } from "react";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import { Routes } from "../../_components";
import { BscBlob } from "../../_components/bsc-blob";
import { userConstants } from "../../_constants";
import "../../assets/css/bsc.css";
import moreBsc from "../../assets/images/moreBsc.png";

const { months, seasons, sixMonths, year } = userConstants;

const titles = [
  {
    name: "وجه کارت امتیازی متوازن (BSC)",
    className: "first-title",
    background: "#3773a9",
  },
  { name: "عنوان شاخص", background: "#3773a9" },
  {
    name: "واحد اندازه گیری",
    className: "first-unit ",
    background: "#3773a9",
  },
  { name: "تارگت (هدف)", background: "#3773a9" },
  {
    children: {
      col: false,
      childBtns: months.map((_, i) => {
        return {
          childName: months[i],
          className: "row-interval-title",
          background: i % 2 ? "#3773a9" : "#104c82",
        };
      }),
    },
  },
  { name: "وضعیت موجود", background: "#3773a9" },
];

const sides = [
  "جامعه و عرضه خدمات",
  "فرآیندهای داخلی",
  "رشد و یادگیری",
  "مالی",
];

const sidesForShow = [
  "جامعـه و عرضـه خدمـات",
  "فرآینـدهـای داخلـی",
  "رشـد و یادگیـری",
  "مالـی",
];

const colors = ["#719ec8", "#70bbc0", "#72c2e5", "#7389a1"];
const colorsSide = ["#3483bc", "#3e9775", "#31a0b5", "#355e8a"];

const lightColors = [
  "rgb(231, 46, 80)",
  "rgb(95, 228, 126)",
  "rgb(250, 210, 92)",
  "rgb(187, 186, 186)",
];

// "rgb(220, 5, 45)",
// "rgb(78, 185, 103)",
// "rgb(250, 208, 80)",
// "rgb(182, 181, 181)",
const darkColors = [
  "rgb(220, 5, 45)",
  "rgb(48, 180, 79)",
  "rgb(238, 193, 57)",
  "rgb(182, 181, 181)",
];

const lightFont = "#fff";
const darkFont = "#fff";

class bscTable_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      sideTitles: [
        {
          name: sidesForShow[0],
          background: colorsSide[0],
          height: "200px",
          className: "side side-0",
          rotateText: false,
        },
        {
          name: sidesForShow[1],
          background: colorsSide[1],
          height: "200px",
          className: "side side-1",
          rotateText: false,
        },
        {
          name: sidesForShow[2],
          background: colorsSide[2],
          height: "200px",
          className: "side side-2",
          rotateText: false,
        },
        {
          name: sidesForShow[3],
          background: colorsSide[3],
          height: "200px",
          className: "side side-3",
          rotateText: false,
        },
      ],
    };
    this.globalStorage = this.props.globalStorage;
  }

  componentDidMount = () => {
    this.getCompactWithData();
    document.querySelector(".wave").classList.add("hidden");
  };

  componentWillUnmount = () => {
    document.querySelector(".wave").classList.remove("hidden");
  };

  fixNum = (num) => {
    return num % 1
      ? `${num.toFixed(2)}` === `0.00`
        ? num.toFixed(4)
        : num.toFixed(2)
      : `${num}`;
  };

  mapIntervals = (
    dateUnit,
    intervals,
    desirability,
    lower_limit,
    upper_limit,
    sideIndex,
    rowIndex,
    className
  ) => {
    const { fixNum, getBackground } = this;
    let sortedIntervals = intervals
      .slice()
      .sort((a, b) => a.interval_number - b.interval_number, 0)
      .map((item) =>
        item.average === null
          ? {
              ...item,
              average: "-",
            }
          : item
      );
    console.log(sortedIntervals);

    return dateUnit.map((_, i) => {
      const dataForThisMonth = sortedIntervals.find(
        (interval) => interval.interval_number === i + 1
      );
      if (dataForThisMonth !== undefined) {
        return {
          childName: dataForThisMonth ? fixNum(dataForThisMonth.average) : "-",
          className: `color-dark group-${sideIndex} row-${sideIndex}-${rowIndex} row-interval row-interval-${sideIndex}-${rowIndex} ${className}`,
          background: getBackground(
            dataForThisMonth,
            desirability,
            lower_limit,
            upper_limit
          ),
        };
      }
      return {
        childName: "-",
        className: `color-dark group-${sideIndex} row-${sideIndex}-${rowIndex} row-interval row-interval-${sideIndex}-${rowIndex} ${className}`,
        background: lightColors[3],
      };
    });
  };

  setupRow = (section, color, sideIndex) => {
    const { fixNum, mapIntervals } = this;

    return section
      .map(
        (
          {
            title,
            measurement_unit,
            target,
            total_average,
            intervals,
            measure_interval,
            desirability,
            lower_limit,
            upper_limit,
          },
          rowIndex
        ) => {
          let intervalData = [];
          switch (measure_interval) {
            case "ماهانه":
              intervalData = mapIntervals(
                months,
                intervals,
                desirability,
                lower_limit,
                upper_limit,
                sideIndex,
                rowIndex,
                "month"
              );
              break;
            case "سالانه":
              intervalData = mapIntervals(
                year,
                intervals,
                desirability,
                lower_limit,
                upper_limit,
                sideIndex,
                rowIndex,
                "year"
              );
              break;
            case "شش ماه یکبار":
              intervalData = mapIntervals(
                sixMonths,
                intervals,
                desirability,
                lower_limit,
                upper_limit,
                sideIndex,
                rowIndex,
                "six-month"
              );
              break;
            case "سه ماه یکبار":
              intervalData = mapIntervals(
                seasons,
                intervals,
                desirability,
                lower_limit,
                upper_limit,
                sideIndex,
                rowIndex,
                "season"
              );
              break;
            default:
              break;
          }

          return [
            {
              name: title,
              background: color,
              className: `group-${sideIndex} row-${sideIndex}-${rowIndex} title`,
            },
            {
              name: measurement_unit,
              background: color,
              className: `group-${sideIndex} row-${sideIndex}-${rowIndex} unit`,
            },
            {
              name: target,
              background: color,
              className: `group-${sideIndex} row-${sideIndex}-${rowIndex} target`,
            },
            {
              children: {
                col: false,
                childBtns: intervalData,
              },
            },
            {
              name: total_average
                ? fixNum(total_average)
                : "مقدار ثبت نشده است",
              background: color,
              className: `group-${sideIndex} row-${sideIndex}-${rowIndex} total`,
            },
          ];
        }
      )
      .flat();
  };

  getCompactWithData = () => {
    const { handleRow, setupRow } = this;
    const { sideTitles } = this.state;
    const { year } = this.globalStorage;
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v2/indicator/compact_with_data_bsc?year=${year}`
        )
      )
      .then((res) => {
        //add data to table
        let sections = sides.map((item) =>
          res.data
            .filter((obj) => obj.score_card_aspect === item)
            .sort((a, b) => a.bsc_weight - b.bsc_weight, 0)
            .reverse()
        );

        const allData = sections.map((_, i) =>
          setupRow(sections[i], colors[i], i)
        );
        allData.map((_, i) => handleRow(i, allData[i]));

        //handle side titles height
        // const sideTitlesHeights = sections.map(
        //   (section) => section.length * (4.35 + 55)
        // );
        const sideTitlesHeights = sections.map(
          (section) => section.length * 55 + (section.length - 1) * 5
        );
        this.setState({
          sideTitles: sideTitles.map((title, i) => {
            return {
              ...title,
              height: `${sideTitlesHeights[i]}px`,
              rotateText: sections[i].length > 3,
            };
          }),
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getBackground = (interval, desirability, lower_limit, upper_limit) => {
    if (interval && interval.average !== undefined) {
      // if (interval.average === "-") return lightColors[3];
      if (lower_limit !== null && upper_limit !== null) {
        if (desirability === "افزاینده") {
          return interval.average < lower_limit
            ? lightColors[0]
            : interval.average >= upper_limit
            ? lightColors[1]
            : lightColors[2];
        } else {
          return interval.average > lower_limit &&
            interval.average < upper_limit
            ? lightColors[2]
            : interval.average <= lower_limit
            ? lightColors[1]
            : lightColors[0];
        }
      } else {
        return lightColors[3];
      }
    }
    return lightColors[3];
  };

  handleRow = (index, val) => {
    const { rows } = this.state;
    const { addEventListeners } = this;
    const arr = [...rows];
    arr[index] = val;
    if (index === 3) {
      this.setState({ rows: arr }, addEventListeners);
    }
    this.setState({ rows: arr });
  };

  returnOppositeColor = (val, currColors, oppColors) => {
    switch (val) {
      case currColors[0]: {
        return oppColors[0];
      }
      case currColors[1]: {
        return oppColors[1];
      }
      case currColors[2]: {
        return oppColors[2];
      }
      case currColors[3]: {
        return oppColors[3];
      }
    }
  };

  addEventListeners = () => {
    const { returnOppositeColor } = this;
    const { sideTitles, rows } = this.state;

    //hover for sides
    Array.from({ length: sideTitles.length }).map((_, i) => {
      const side = document.querySelector(`.side-${i}`);
      const allBtnsInSide = document.querySelectorAll(`.group-${i}`);

      side.addEventListener("mouseover", () => {
        allBtnsInSide.forEach((btn) => {
          if (btn.classList.contains(`row-interval`)) {
            btn.style.background = returnOppositeColor(
              btn.style.background,
              lightColors,
              darkColors
            );
            btn.style.color = lightFont;
          } else {
            btn.classList.add(`hoverAllBtnsInSide-${i}`);
          }
        });
      });

      side.addEventListener("mouseout", () => {
        allBtnsInSide.forEach((btn) => {
          if (btn.classList.contains(`row-interval`)) {
            btn.style.background = returnOppositeColor(
              btn.style.background,
              darkColors,
              lightColors
            );
            btn.style.color = darkFont;
          } else {
            btn.classList.remove(`hoverAllBtnsInSide-${i}`);
          }
        });
      });
    });

    //hover for whole row
    // it's number of every blob (and Parent blob for month or sixMonth or...)
    // divide to 5 to get number of rows in every side
    const allRowsLen = rows.reduce((a, section) => a + section.length / 5, 0);
    const RowsInSectionsLen = rows.map((section) => section.length / 5);

    Array.from({ length: allRowsLen }).map((_, i) => {
      if (i < RowsInSectionsLen[0]) {
        // we're in first section
        const allBtnsInRow = document.querySelectorAll(`.row-${0}-${i}`);
        const allIntervalBtnsInRow = document.querySelectorAll(
          `.row-interval-${0}-${i}`
        );

        allBtnsInRow.forEach((btn) => {
          btn.addEventListener("mouseover", () => {
            allBtnsInRow.forEach((btn) => {
              if (!btn.classList.contains(`row-interval-${0}-${i}`))
                btn.classList.add(`hoverWholeRow-${0}`);

              allIntervalBtnsInRow.forEach((btn) => {
                btn.style.background = returnOppositeColor(
                  btn.style.background,
                  lightColors,
                  darkColors
                );
                btn.style.color = lightFont;
              });
            });
          });

          btn.addEventListener("mouseout", () => {
            allBtnsInRow.forEach((btn) => {
              if (!btn.classList.contains(`row-interval-${0}-${i}`))
                btn.classList.remove(`hoverWholeRow-${0}`);

              allIntervalBtnsInRow.forEach((btn) => {
                btn.style.background = returnOppositeColor(
                  btn.style.background,
                  darkColors,
                  lightColors
                );
                btn.style.color = darkFont;
              });
            });
          });
        });
      }
      if (i < RowsInSectionsLen[1]) {
        // we're in second section
        const rowIndex = i - Array.from(RowsInSectionsLen[0]).length;
        const allBtnsInRow = document.querySelectorAll(`.row-${1}-${rowIndex}`);
        const allIntervalBtnsInRow = document.querySelectorAll(
          `.row-interval-${1}-${rowIndex}`
        );

        allBtnsInRow.forEach((btn) => {
          btn.addEventListener("mouseover", () => {
            allBtnsInRow.forEach((btn) => {
              if (!btn.classList.contains(`row-interval-${1}-${rowIndex}`))
                btn.classList.add(`hoverWholeRow-${1}`);

              allIntervalBtnsInRow.forEach((btn) => {
                btn.style.background = returnOppositeColor(
                  btn.style.background,
                  lightColors,
                  darkColors
                );
                btn.style.color = lightFont;
              });
            });
          });

          btn.addEventListener("mouseout", () => {
            allBtnsInRow.forEach((btn) => {
              if (!btn.classList.contains(`row-interval-${1}-${rowIndex}`))
                btn.classList.remove(`hoverWholeRow-${1}`);

              allIntervalBtnsInRow.forEach((btn) => {
                btn.style.background = returnOppositeColor(
                  btn.style.background,
                  darkColors,
                  lightColors
                );
                btn.style.color = darkFont;
              });
            });
          });
        });
      }
      if (i < RowsInSectionsLen[2]) {
        // we're in third section
        const rowIndex =
          i -
          Array.from(RowsInSectionsLen[1]).length -
          Array.from(RowsInSectionsLen[0]).length;
        const allBtnsInRow = document.querySelectorAll(`.row-${2}-${rowIndex}`);
        const allIntervalBtnsInRow = document.querySelectorAll(
          `.row-interval-${2}-${rowIndex}`
        );

        allBtnsInRow.forEach((btn) => {
          btn.addEventListener("mouseover", () => {
            allBtnsInRow.forEach((btn) => {
              if (!btn.classList.contains(`row-interval-${2}-${rowIndex}`))
                btn.classList.add(`hoverWholeRow-${2}`);

              allIntervalBtnsInRow.forEach((btn) => {
                btn.style.background = returnOppositeColor(
                  btn.style.background,
                  lightColors,
                  darkColors
                );
                btn.style.color = lightFont;
              });
            });
          });

          btn.addEventListener("mouseout", () => {
            allBtnsInRow.forEach((btn) => {
              if (!btn.classList.contains(`row-interval-${2}-${rowIndex}`))
                btn.classList.remove(`hoverWholeRow-${2}`);

              allIntervalBtnsInRow.forEach((btn) => {
                btn.style.background = returnOppositeColor(
                  btn.style.background,
                  darkColors,
                  lightColors
                );
                btn.style.color = darkFont;
              });
            });
          });
        });
      }
      if (i < RowsInSectionsLen[3]) {
        // we're in fourth section
        const rowIndex =
          i -
          Array.from(RowsInSectionsLen[2]).length -
          Array.from(RowsInSectionsLen[1]).length -
          Array.from(RowsInSectionsLen[0]).length;
        const allBtnsInRow = document.querySelectorAll(`.row-${3}-${rowIndex}`);
        const allIntervalBtnsInRow = document.querySelectorAll(
          `.row-interval-${3}-${rowIndex}`
        );

        allBtnsInRow.forEach((btn) => {
          btn.addEventListener("mouseover", () => {
            allBtnsInRow.forEach((btn) => {
              if (!btn.classList.contains(`row-interval-${3}-${rowIndex}`))
                btn.classList.add(`hoverWholeRow-${3}`);

              allIntervalBtnsInRow.forEach((btn) => {
                btn.style.background = returnOppositeColor(
                  btn.style.background,
                  lightColors,
                  darkColors
                );
                btn.style.color = lightFont;
              });
            });
          });

          btn.addEventListener("mouseout", () => {
            allBtnsInRow.forEach((btn) => {
              if (!btn.classList.contains(`row-interval-${3}-${rowIndex}`))
                btn.classList.remove(`hoverWholeRow-${3}`);

              allIntervalBtnsInRow.forEach((btn) => {
                btn.style.background = returnOppositeColor(
                  btn.style.background,
                  darkColors,
                  lightColors
                );
                btn.style.color = darkFont;
              });
            });
          });
        });
      }
    });
  };

  render() {
    const { rows, sideTitles } = this.state;
    return (
      <div className="content bg-light bg-drr pt-3 pb-5 px-3 bsc">
        <Routes page="bsc" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 tableTitles boldFont">
              <div className="tableTitle">
                {titles !== undefined &&
                  titles.map((btn, i) => {
                    const {
                      name,
                      background,
                      className: classNameBtn,
                      children,
                    } = btn;

                    if (children) {
                      return <ParentBlob key={i} btn={btn} />;
                    }

                    return (
                      <BscBlob
                        key={i}
                        name={name}
                        background={background}
                        className={classNameBtn}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="tableContents">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12 tableSideTitles boldFont">
                      {sideTitles.map(
                        (
                          { name, background, height, className, rotateText },
                          i
                        ) => (
                          <BscBlob
                            key={i}
                            name={name}
                            background={background}
                            height={height}
                            className={className}
                            rotateText={rotateText}
                          />
                        )
                      )}
                    </div>
                  </div>
                </div>
                <div className="container-fluid">
                  {rows.map((row, i) => (
                    <div key={i} className={`tableContent boldFont test-${i}`}>
                      {row !== undefined &&
                        row.map((btn, j) => {
                          const {
                            name,
                            background,
                            className: classNameBtn,
                            children,
                          } = btn;

                          if (children) {
                            return <ParentBlob key={j} btn={btn} />;
                          }

                          return (
                            <BscBlob
                              key={j}
                              name={name}
                              background={background}
                              className={classNameBtn}
                            />
                          );
                        })}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class ParentBlob extends Component {
  render() {
    const { btn } = this.props;
    const { col, childBtns } = btn.children;

    return (
      <BscBlob dir={col ? "column" : "row"}>
        {childBtns.map((_, i) => {
          const { childName, background, className } = childBtns[i];
          let icon = true;
          if (className === "row-interval-title") {
            icon = false;
          }
          if (childName === "-") {
            icon = false;
          }
          if (childBtns[i].hasOwnProperty("childBtns")) {
            return (
              <BscBlob dir="row">
                {childBtns[i].childBtns.map((x, i) => {
                  if (x.hasOwnProperty("className")) {
                    return (
                      <BscBlob
                        key={i}
                        name={x.childName}
                        className={x.className}
                        background={background}
                        child={true}
                      />
                    );
                  }
                  return (
                    <BscBlob
                      key={i}
                      name={x.childName}
                      background={background}
                      child={true}
                    />
                  );
                })}
              </BscBlob>
            );
          }
          return (
            <BscBlob
              key={i}
              name={childName}
              className={className}
              background={background}
              child={true}
              icon={icon}
              img={moreBsc}
            />
          );
        })}
      </BscBlob>
    );
  }
}

const bscTable = connect((state) => ({
  globalStorage: state.globalStorage,
}))(bscTable_);
export { bscTable };
